import React from 'react';
import { ReviewEvent } from 'types';
import { formatIsoToHHMM } from 'utils/time';
import './ReviewedByCard.css';

type ReviewedByCardProps = {
  timelineObject: ReviewEvent;
};
export default function ReviewedByCard({ timelineObject }: ReviewedByCardProps) {
  const formattedDate = formatIsoToHHMM(timelineObject.event_datetime);
  return (
    <div className='reviewed-by-container'>
      <div className='reviewed-by-text'>Reviewed by {timelineObject.user_name}</div>
      <div className='reviewed-by-date'>{formattedDate}</div>
    </div>
  );
}
